export const ERROR_CODES = {
  EMAIL_EXISTS: "email_exists",
  EMAIL_EXISTS_WITH_OLDER: "email_exists_with_older",
  EMAIL_EXISTS_WITH_PENDING: "email_exists_with_pending",
};
